// Function component (presentational):

import React from 'react'

import LayoutWrapper from '../shared/styledComponents/page/LayoutWrapper'
import PageWrapper from '../shared/styledComponents/page/PageWrapper'

import NavContainer from '../nav/NavContainer'
import LibraContainer from '../libra/LibraStatefulContainer'

import SubscriptionContainer from './SubscriptionContainer'

const SubscriptionView = () => (
	<LayoutWrapper>
		<NavContainer sleekNav />

		<PageWrapper>
			<SubscriptionContainer />
		</PageWrapper>

		<LibraContainer />
	</LayoutWrapper>
)

export default SubscriptionView
